import { ArticleMeta, articleTag } from "./types";

const META: ArticleMeta = {
    slug: "data-platform-scaleup",
    section: "portfolio",
    header: "Biomedical Research",
    title: "Scaling researcher's capacity to hypothesize and iterate.",
    description: "Ingestion, lineage, and serving layers rebuilt for high-volume analytics and ML.",
    tags: [
        articleTag("kafka.svg"),
        articleTag("postgresql.svg"),
        articleTag("elasticsearch.svg"),
        articleTag("mongo-svgrepo-com.svg"),
        articleTag("python.svg"),
    ],
    url: "/articles/data-platform-scaleup",
};

export default META;
